//#region import bloc
import { NbiDimensions } from "../../generic/generic-nbi-dimensions";
import { NBIKpis } from "../../generic/generic-nbi-domains";
import { IExportColumn } from "../../salescredit/salescredit-types";
//#endregion

const portfolioClientId = "Portfolio Client Id";
const portfolioClientName = "Portfolio Client Name";
const coriGroupId = "GLBA client group ID";
const coriGroupName = "GLBA client group name";
const clientSubGroupId = "Client Sub Group Id";
const clientSubGroup = "Client Sub Group";
const clientLegalEntityId = "Client Legal Entity Id";
const clientLegalEntity = "Client Legal Entity";
const portfolioClientCountry = "Portfolio Client Country";
const originatingEntity = "Originating Entity";
const clientRCTforLegalEntity = "Client RCT for Legal Entity";
const businessLine = "Business Line";
const subBusinessLine = "Sub Business Line";
const clientGroupName = "Client Group Name";

//#region Portfolio & Client snapshot
export function DealList_Columns(): IExportColumn[] {
  const attrs = new NbiDimensions();
  const kpis = new NBIKpis();
  return [
    { field: attrs.DIM_DEAL_CODE, headerName: "Deal Code" },
    { field: attrs.CALENDAR_DATE, headerName: "Deal credit Date" },
    { field: attrs.PERIOD_MONTH_LABEL, headerName: "Month" },
    { field: attrs.YEAR, headerName: "Year" },
    { field: attrs.CLIENT_GEN_ID, headerName: portfolioClientId },
    { field: attrs.CLIENT_GEN_NAME, headerName: portfolioClientName },
    { field: attrs.CLIENT_CORIGRPCOMID, headerName: coriGroupId },
    { field: attrs.CLIENT_CORIGRPNAME, headerName: coriGroupName },
    { field: attrs.SUB_GRP_ID, headerName: clientSubGroupId },
    { field: attrs.SUB_GRP_FULL_NAME, headerName: clientSubGroup },
    { field: attrs.LE_ID, headerName: clientLegalEntityId },
    { field: attrs.CLIENT_LENAME, headerName: clientLegalEntity },
    {
      field: attrs.CLIENT_GEN_COM_CTRY_LABEL,
      headerName: portfolioClientCountry,
    },
    { field: attrs.EC_ID, headerName: "EC Id" },
    { field: attrs.EC_FULL_NAME, headerName: "EC Name" },
    { field: attrs.FPV_BL, headerName: "BL" },
    { field: attrs.FPV_SBL, headerName: "SBL" },
    { field: attrs.FPV_SSBL, headerName: "SSBL" },
    { field: attrs.SALES_TEAM_NAME, headerName: "Sales Team name" },
    { field: attrs.SALES, headerName: "Sales" },
    { field: attrs.OE_SHORT_LABEL, headerName: originatingEntity },
    { field: attrs.OE_RES_CTRY, headerName: "OE Country" },
    { field: attrs.PRODUCT_LEVEL1, headerName: "Product Level 1" },
    { field: attrs.PRODUCT_LEVEL2, headerName: "Product Level 2" },
    { field: attrs.PRODUCT_LEVEL3, headerName: "Product Level 3" },
    { field: attrs.IS_IB, headerName: "IB/Non IB" },
    {
      field: attrs.CLIENT_LE_RCT_CODE,
      headerName: clientRCTforLegalEntity,
    },
    { field: kpis.NBI_NBI, headerName: "NBI" },
    { field: kpis.RWA_BY_DATE, headerName: "RWA Stock" },
    { field: attrs.PO_LEFULLNAME, headerName: "Primary Obligor Name" },
    { field: attrs.SALESBEN_SALES_LOCATION, headerName: "Sales Location" },
    { field: attrs.BOOKING_PLACE, headerName: "Booking Place" },
  ];
}

export function DealList_DefaultColumns(): IExportColumn[] {
  const attrs = new NbiDimensions();
  const kpis = new NBIKpis();
  return [
    { field: attrs.DIM_DEAL_CODE, headerName: "Deal Code" },
    { field: attrs.CALENDAR_DATE, headerName: "Deal credit Date" },
    { field: attrs.PERIOD_MONTH_LABEL, headerName: "Month" },
    { field: attrs.YEAR, headerName: "Year" },
    { field: attrs.CLIENT_GEN_ID, headerName: portfolioClientId },
    { field: attrs.CLIENT_GEN_NAME, headerName: portfolioClientName },
    { field: attrs.CLIENT_CORIGRPCOMID, headerName: coriGroupId },
    { field: attrs.CLIENT_CORIGRPNAME, headerName: coriGroupName },
    { field: attrs.SUB_GRP_ID, headerName: clientSubGroupId },
    { field: attrs.SUB_GRP_FULL_NAME, headerName: clientSubGroup },
    { field: attrs.LE_ID, headerName: clientLegalEntityId },
    { field: attrs.CLIENT_LENAME, headerName: clientLegalEntity },
    {
      field: attrs.CLIENT_GEN_COM_CTRY_LABEL,
      headerName: portfolioClientCountry,
    },
    { field: attrs.EC_ID, headerName: "EC Id" },
    { field: attrs.EC_FULL_NAME, headerName: "EC Name" },
    { field: attrs.FPV_BL, headerName: "BL" },
    { field: attrs.FPV_SBL, headerName: "SBL" },
    { field: attrs.FPV_SSBL, headerName: "SSBL" },
    { field: attrs.OE_SHORT_LABEL, headerName: originatingEntity },
    { field: attrs.OE_RES_CTRY, headerName: "OE Country" },
    { field: attrs.PRODUCT_LEVEL1, headerName: "Product Level 1" },
    { field: attrs.PRODUCT_LEVEL2, headerName: "Product Level 2" },
    { field: attrs.PRODUCT_LEVEL3, headerName: "Product Level 3" },
    { field: attrs.IS_IB, headerName: "IB/Non IB" },
    { field: kpis.NBI_NBI, headerName: "NBI" },
    { field: kpis.RWA_BY_DATE, headerName: "RWA Stock" },
    { field: attrs.SALES_TEAM_NAME, headerName: "Sales Team name" },
    { field: attrs.SALES, headerName: "Sales" },
    { field: attrs.SALESBEN_SALES_LOCATION, headerName: "Sales Location" },
  ];
}
export function ClientList_Attributes(): IExportColumn[] {
  const attrs = new NbiDimensions();
  return [
    { field: attrs.CLIENT_GEN_ID, headerName: portfolioClientId },
    { field: attrs.CLIENT_GEN_NAME, headerName: portfolioClientName },
    { field: attrs.BE_RES_CTRY_NAME, headerName: "Booking Country" },
    { field: attrs.BE_SHORT_LABEL, headerName: "Booking Entity" },
    { field: attrs.AGENCY_DEC_LONG_NAME, headerName: "Booking Place" },
    { field: attrs.OE_RES_CTRY_NAME, headerName: "Originating Country" },
    { field: attrs.OE_RES_REG_CODE, headerName: "Originating Region" },
    { field: attrs.OE_SHORT_LABEL, headerName: originatingEntity },
    { field: attrs.FPV_BL, headerName: businessLine },
    { field: attrs.FPV_SBL, headerName: subBusinessLine },
    { field: attrs.FPV_SSBL, headerName: "Sub Sub Business Line" },
    { field: attrs.CLIENT_CORIGRPCOMID, headerName: coriGroupId },
    { field: attrs.CLIENT_CORIGRPNAME, headerName: coriGroupName },
    {
      field: attrs.CLIENT_GEN_COM_CTRY_LABEL,
      headerName: portfolioClientCountry,
    },
    { field: attrs.CLIENT_GEN_REG_NAME, headerName: "Portfolio Client Region" },
    {
      field: attrs.CLIENT_GEN_SUB_REG_NAME,
      headerName: "Portfolio Client Sub Region",
    },
    { field: attrs.CLIENT_GEN_FUP_CLASS_LABEL, headerName: "Portfolio PCRU" },
    { field: attrs.CLIENT_GEN_SEGMENT, headerName: "Portfolio Client Segment" },
    {
      field: attrs.CLIENT_GEN_CTRY_AXIS_LABEL,
      headerName: "Portfolio Client Steering Country",
    },
    {
      field: attrs.CLIENT_LEADCORIBANKER,
      headerName: "GLBA client lead banker",
    },
    { field: attrs.CLIENT_CORIGRPSEGMENT, headerName: "GLBA client segment" },
    {
      field: attrs.CLIENT_CORI_CTRY_AXIS,
      headerName: "GLBA client steering country",
    },
    { field: attrs.CLIENT_GEN_TYPL1, headerName: "Typology Level 1" },
    { field: attrs.CLIENT_GEN_TYPL2, headerName: "Typology Level 2" },
    { field: attrs.CLIENT_GEN_TYPL3, headerName: "Typology Level 3" },
    { field: attrs.CLIENT_GEN_LEVEL, headerName: "Portfolio Client Level" },
    { field: attrs.CLIENT_LENAME, headerName: clientLegalEntity },
    { field: attrs.CLIENT_LEID, headerName: clientLegalEntityId },
    { field: attrs.SUB_GRP_ID, headerName: clientSubGroupId },
    { field: attrs.SUB_GRP_FULL_NAME, headerName: clientSubGroup },
    { field: attrs.CLIENT_COUNTRY, headerName: "Commercial country of LE" },
    { field: attrs.PRODUCT_LEVEL1, headerName: "Product Level1" },
    { field: attrs.PRODUCT_LEVEL2, headerName: "Product Level2" },
    { field: attrs.PRODUCT_LEVEL3, headerName: "Product Level3" },
    { field: attrs.SALESBEN_SALES_LOCATION, headerName: "Sales Location" },
    {
      field: attrs.CLIENT_LE_RCT_CODE,
      headerName: clientRCTforLegalEntity,
    },
    { field: attrs.CLIENT_GRPID, headerName: "Client Group Id" },
    {
      field: attrs.GRP_FULL_NAME,
      headerName: clientGroupName,
    },
    {
      field: attrs.NBI_GBIS_LEVEL_1_FUNCTIONAL_LABEL,
      headerName: "NBI breakdown level 1",
    },
    {
      field: attrs.NBI_GBIS_LEVEL_6_FUNCTIONAL_LABEL,
      headerName: "NBI breakdown level 6",
    },
    {
      field: attrs.NBI_GBIS_LEVEL_7_FUNCTIONAL_LABEL,
      headerName: "NBI breakdown level 7",
    },
    { field: attrs.PRODUCT_LABEL, headerName: "Product Label" },
    { field: attrs.PRODUCT_CODE, headerName: "Product Code" },
  ];
}

export function ClientGroup_Attributes(): IExportColumn[] {
  const attrs = new NbiDimensions();
  return [
    { field: attrs.CLIENT_GRPID, headerName: "Client Group BDR CCIAL ID" },
    {
      field: attrs.GRP_FULL_NAME,
      headerName: clientGroupName,
    },
    {
      field: attrs.CLIENT_GRP_COM_CONTINENT,
      headerName: "Client Group Continent Name",
    },
    {
      field: attrs.CLIENT_GRP_COUNTRY_AXIS,
      headerName: "Client Group Country Axis",
    },
    {
      field: attrs.CLIENT_GRP_COM_COUNTRY_GRP_NAME,
      headerName: "Client Group Country Grouping Name",
    },
    {
      field: attrs.GRP_COUNTRY,
      headerName: "Client Group Country Name",
    },
    {
      field: attrs.CLIENT_GRP_FUP_CLASS_LABEL,
      headerName: "Client Group PCRU",
    },
    { field: attrs.GRP_COMREGION, headerName: "Client Group Region Name" },
    { field: attrs.CLIENT_GRP_SEGMENT, headerName: "Client Group Segment" },
    {
      field: attrs.GRP_COMSUBREGION,
      headerName: "Client Group Sub Region Name",
    },

    { field: attrs.GRP_TYPL1, headerName: "Client Group Typology Level 1" },
    { field: attrs.GRP_TYPL2, headerName: "Client Group Typology Level 2" },
    { field: attrs.GRP_TYPL3, headerName: "Client Group Typology Level 3" },
    { field: attrs.SUB_GRP_ID, headerName: "Client Sub Group BDR CCIAL ID" },
    { field: attrs.SUB_GRP_FULL_NAME, headerName: "Client Sub Group Name" },
    { field: attrs.CLIENT_LEID, headerName: "Client LE BDR CCIAL ID" },
    { field: attrs.CLIENT_LENAME, headerName: "Client LE Name" },
    { field: attrs.EC_ID, headerName: "Client EC BDR CCIAL ID" },
    { field: attrs.EC_FULL_NAME, headerName: "Client EC Name" },
    { field: attrs.BE_RES_CTRY_NAME, headerName: "Booking Entity Country" },
    { field: attrs.FPV_BE_RESG, headerName: "Booking Entity Region" },

    { field: attrs.OE_RES_CTRY_NAME, headerName: "Originating Entity Country" },
    { field: attrs.OE_RES_REG, headerName: "Originating Entity Region" },
    { field: attrs.FPV_BL, headerName: businessLine },
    { field: attrs.FPV_SBL, headerName: subBusinessLine },
    { field: attrs.FPV_SSBL, headerName: "Sub Sub Business Line" },
    {
      field: attrs.NBI_GBIS_LEVEL_1_FUNCTIONAL_LABEL,
      headerName: "NBI breakdown level 1",
    },
    {
      field: attrs.NBI_GBIS_LEVEL_6_FUNCTIONAL_LABEL,
      headerName: "NBI breakdown level 6",
    },
    {
      field: attrs.NBI_GBIS_LEVEL_7_FUNCTIONAL_LABEL,
      headerName: "NBI breakdown level 7",
    },
    { field: attrs.PRODUCT_LEVEL1, headerName: "Product Level1" },
    { field: attrs.PRODUCT_LEVEL2, headerName: "Product Level2" },
    { field: attrs.PRODUCT_LEVEL3, headerName: "Product Level3" },
    { field: attrs.PRODUCT_LABEL, headerName: "Product Label" },
    { field: attrs.PRODUCT_CODE, headerName: "Product Code" },
    {
      field: attrs.CLIENT_LE_RCT_CODE,
      headerName: clientRCTforLegalEntity,
    },
  ];
}

export function nbi_kpis(): IExportColumn[] {
  return [
    { field: "nbi_ytd", headerName: "NBI YTD" },
    { field: "nbi_ytd_gbis", headerName: "NBI YTD-GBIS" },
    { field: "nbi_ytd_ib", headerName: "NBI YTD-IB" },
    { field: "nbi_ytd_nongbis", headerName: "NBI YTD-Non GBIS" },
    { field: "nbi_ytd_var_yoy", headerName: "NBI YTD var YoY" },
    { field: "nbi_ytd_1", headerName: "NBI YTD-1" },
    { field: "nbi_ytd_ib_1", headerName: "NBI YTD-1 IB" },
    { field: "nbi_ytd_1_gbis", headerName: "NBI YTD-1 GBIS" },
    { field: "nbi_ytd_2_gbis", headerName: "NBI YTD-2 GBIS" },
    { field: "nbi_ytd_3_gbis", headerName: "NBI YTD-3 GBIS" },
    { field: "nbi_ytd_2", headerName: "NBI YTD Y-2" },
    { field: "nbi_ytd_3", headerName: "NBI YTD Y-3" },
    { field: "nbi_fy_1", headerName: "NBI FY-1" },
    { field: "nbi_fy_1_ib", headerName: "NBI FY-1 - IB" },
    { field: "nbi_fy_2_ib", headerName: "NBI FY-2 - IB" },
    { field: "nbi_fy_3_ib", headerName: "NBI FY-3 - IB" },
    { field: "nbi_fy_1_gbis", headerName: "NBI FY-1 - GBIS" },
    { field: "nbi_fy_2", headerName: "NBI FY Y-2" },
    { field: "nbi_fy_3", headerName: "NBI FY Y-3" },
    { field: "nbi_mtd", headerName: "NBI MTD" },
    { field: "nbi_mtd_1", headerName: "NBI MTD Y-1" },
    { field: "nbi_fy_var_yoy", headerName: "NBI FY var YoY" },
    { field: "nbi_forcast_y1", headerName: "NBI Forecast YR1" },
    { field: "nbi_forcast_y1_gbis", headerName: "NBI Forecast YR1 - GBIS" },
    { field: "nbi_forcast_y1_ib", headerName: "NBI Forecast YR1 - IB" },
    {
      field: "nbi_forcast_y1_nongbis",
      headerName: "NBI Forecast YR1 - Non GBIS",
    },
    { field: "nbi_forcast_y1_var_yoy", headerName: "NBI Forecast YR1 var YoY" },
    { field: "nbi_rwa_avg", headerName: "RWA AVG YTD" },
    { field: "nbi_rwa_gbis", headerName: "RWA AVG YTD - GBIS" },
    { field: "nbi_rwa_fy_1", headerName: "RWA AVG FY-1" },
    { field: "nbi_rwa_fy_1_gbis", headerName: "RWA AVG FY-1 - GBIS" },
    { field: "nbi_rwa_fy_2", headerName: "RWA AVG FY-2" },
    { field: "nbi_rwa_fy_3", headerName: "RWA AVG FY-3" },
    { field: "nbi_rwa_last_period", headerName: "RWA Last Period" },
    { field: "nbi_forcast_rwa_y1", headerName: "RWA Forecast YR1" },
    { field: "nbi_forcast_rwa_y1_gbis", headerName: "Rwa Forecast YR1 - GBIS" },
    { field: "nbi_forcast_rwa_y1_ib", headerName: "RWA Forecast YR1 - IB" },
    {
      field: "nbi_forcast_rwa_y1_nongbis",
      headerName: "Rwa Forecast YR1 - Non GBIS",
    },
    {
      field: "nbi_forecast_rwa_y1_vs_fy_1",
      headerName: "RWA Forecast YR1 vs FY-1",
    },
    {
      field: "nbi_forecast_rwa_y2_vs_fy_1",
      headerName: "RWA Forecast YR2 vs FY-1",
    },
    { field: "nbi_rwa_vs_fy_1", headerName: "RWA YTD vs FY-1" },
    { field: "nbi_rgcp", headerName: "RGCP AVG YTD" },
    { field: "nbi_rgcp_gbis", headerName: "RGCP AVG YTD GBIS" },
    { field: "nbi_forcast_rgcp_y1", headerName: "RGCP Forecast YR1" },
    {
      field: "nbi_forcast_rgcp_y1_gbis",
      headerName: "RGCP Forecast- GBIS YR1",
    },
    { field: "nbi_rgcp_1", headerName: "RGCP FY-1" },
    { field: "nbi_rgcp_fy_1_gbis", headerName: "RGCP FY-1 - GBIS" },
    { field: "nbi_rgcp_fy_2", headerName: "RGCP FY-2" },
    { field: "nbi_rgcp_fy_3", headerName: "RGCP FY-3" },
    { field: "nbi_rgcp_vs_fy_1", headerName: "RGCP YTD vs FY-1" },
    { field: "nbi_h1", headerName: "NBI H1" },
    { field: "nbi_gbis_bud_obj", headerName: "NBI Budget Year" },
    { field: "nbi_ytd_vs_nbi_gbis_bud_obj", headerName: "NBI YTD vs Budget" },
    { field: "nbi_gbis_bud_obj_ib", headerName: "NBI Budget - IB" },
    {
      field: "nbi_ytd_vs_nbi_gbis_bud_obj_ib",
      headerName: "NBI YTD vs Budget - IB",
    },
    { field: "nbi_scbased_fy_1", headerName: "NBI SC based FY-1" },
    { field: "nbi_scbased_fy_2", headerName: "NBI SC based FY-2" },
    { field: "nbi_scbased_fy_1_ib", headerName: "NBI SC based FY-1 - IB" },
    { field: "nbi_scbased_fy_2_ib", headerName: "NBI SC based FY-2 - IB" },
  ];
}

export function ClientList_Columns(): IExportColumn[] {
  const attributes = ClientList_Attributes();
  const kpis = nbi_kpis();
  return attributes.concat(kpis);
}

export function ClientGroup_Columns(): IExportColumn[] {
  const attributes = ClientGroup_Attributes();
  const kpis = nbi_kpis();
  return attributes.concat(kpis);
}

export function clientList_default_common_columns(): IExportColumn[] {
  return [
    { field: "nbi_mtd", headerName: "NBI MTD" },
    { field: "nbi_ytd", headerName: "NBI YTD" },
    { field: "nbi_ytd_1", headerName: "NBI YTD-1" },
    { field: "nbi_ytd_var_yoy", headerName: "NBI YTD var YoY" },
    { field: "nbi_fy_1", headerName: "NBI FY-1" },
    { field: "nbi_mtd_1", headerName: "NBI MTD Y-1" },
    { field: "nbi_rwa_avg", headerName: "RWA AVG YTD" },
    { field: "nbi_rgcp", headerName: "RGCP AVG YTD" },
    { field: "nbi_h1", headerName: "NBI H1" },
    { field: "nbi_forcast_y1", headerName: "NBI Forecast YR1" },
    { field: "nbi_forcast_rwa_y1", headerName: "RWA Forecast YR1" },
    { field: "nbi_rwa_vs_fy_1", headerName: "RWA YTD vs FY-1" },
    { field: "nbi_rgcp_1", headerName: "RGCP FY-1" },
    { field: "nbi_rgcp_vs_fy_1", headerName: "RGCP YTD vs FY-1" },
  ];
}

export function ClientList_Default_Columns(): IExportColumn[] {
  const attrs = new NbiDimensions();
  const columns = clientList_default_common_columns();
  columns.push({ field: attrs.FPV_BL, headerName: businessLine });
  columns.push({ field: attrs.FPV_SBL, headerName: subBusinessLine });
  return columns;
}

export function ClientGroup_Default_Columns(): IExportColumn[] {
  const attrs = new NbiDimensions();
  const columns = clientList_default_common_columns();
  columns.push({ field: attrs.GRP_FULL_NAME, headerName: clientGroupName });
  return columns;
}

export function Portfolio_ClientList_Default_Columns(): IExportColumn[] {
  const attrs = new NbiDimensions();
  const columns = clientList_default_common_columns();
  columns.push({
    field: attrs.CLIENT_GEN_NAME,
    headerName: "Portfolio Client Name",
  });
  return columns;
}
